import Vue from 'vue'
import {ACCESS_TOKEN} from '../store/mutation-types'
import store from '../store'
import {throttle} from './util'
import {getDate, handleTraceFunction} from './trace'
import {traceApi} from '../api/trace'
import router from '../router'

/**
 * IframeMessenger 类用于管理与 iframe 的 postMessage 通信
 */
class IframeMessenger {
  /**
   * 构造函数
   * @param {Object} param0
   * @param {string} param0.domain - iframe 的域名
   * @param {HTMLIFrameElement} param0.iframeElement - iframe 元素
   */
  constructor({ domain, iframeElement, routeQuery }) {
    // 初始化数据
    this.domain = domain
    this.iframeElement = iframeElement
    this.userInfo = store.getters.userInfo
    this.token = Vue.ls.get(ACCESS_TOKEN)
    this.onMessageCallback = null
    this.routeQuery = routeQuery
  }

  /**
   * 发送消息给 iframe
   * @param {Object} param0
   * @param {string} param0.action - 消息动作
   * @param {any} [param0.data] - 携带的数据
   */
  sendMessageToIframe({ action, data }) {
    const message = {
      action,
      status: 'success',
      data,
      timestamp: Date.now(),
    }
    if (this.iframeElement && this.iframeElement.contentWindow) {
      this.iframeElement.contentWindow.postMessage(message, this.domain)
    }
  }

  /**
   * 初始化 iframe 通信
   */
  init() {
    window.addEventListener('message', this.handleMessage)
  }

  /**
   * 注册自定义消息回调
   * @param {Function} callback
   */
  registerOnMessage(callback) {
    this.onMessageCallback = callback
  }

  /**
   * 处理来自 iframe 的消息
   * @param {MessageEvent} event
   */
  handleMessage = (event) => {
    if (event.origin === this.domain) {
      try {
        const { action, data } = event.data

        if (!action) return

        // 自动响应 token 请求
        if (action.indexOf('.auth.getToken') > -1) {
          this.sendMessageToIframe({
            action,
            data: { token: this.token },
          })
        }

        // 自动响应用户信息请求
        if (action.indexOf('.user.getUserInfo') > -1) {
          this.sendMessageToIframe({
            action,
            data: { ...this.userInfo, entrance: this.routeQuery.entrance },
          })
        }

        // 通用点击事件埋点
        if (action.indexOf('.trace.clickFun') > -1) {
          const { functionName, functionUrl, createTime, note } = data
          throttle(
            handleTraceFunction({ functionName, functionUrl, createTime, note }),
            1000
          )
        }

        // 通用页面浏览时长埋点
        if (action.indexOf('.trace.pageView') > -1) {
          const { id, moduleName, pageId, pageName, referrerId, duration, triggerTime } = data
          const pageView = {
            id,
            sessionId: window && localStorage.getItem('sessionId'), // 会话ID
            moduleName,
            pageId,
            pageName,
            referrerId,
            duration,
            incidentType: '2',
            url: pageId,
            urlPath: pageId,
            triggerTime,
            userId: this.userInfo.id,
            sourceUserId: this.routeQuery.userId,
            entrance: this.routeQuery.entrance,
            channel: this.routeQuery.channel,
            campId: this.routeQuery.businessId,
          }
          traceApi(pageView).then((res) => {
            if (!id) {
              this.sendMessageToIframe({ action, data: { id: res.data } })
            }
          })
        }

        // 学习时长埋点
        if (action.indexOf('.trace.learnDuration') > -1) {
          const { id, title, courseId, sectionId, duration, videoDuration, learningStatus } = data
          const pageView = {
            sessionId: window && localStorage.getItem('sessionId'), // 会话ID
            courseId,
            sectionId,
            duration: duration || 1, // 观看视频时长
            incidentType: '3',
            pageName: title,
            triggerTime: getDate(new Date().getTime() - duration * 1000), // 触发时间
            journeyId: '',
            userId: this.userInfo.id, // 用户id
            id,
            entrance: this.routeQuery.entrance,
            campId: this.routeQuery.businessId,
            channel: this.routeQuery.channel,
            videoDuration,
            learningStatus,
          }
          traceApi(pageView).then((res) => {
            if (!id) {
              this.sendMessageToIframe({ action, data: { id: res.data } })
            }
          })
        }

        if (action.indexOf('.router.back') > -1) {
          router.back()
        }

        // 触发外部回调
        if (this.onMessageCallback) {
          this.onMessageCallback({ action, data }, this.sendMessageToIframe.bind(this))
        }
      } catch (e) {
        console.error('❌ Error processing message:', e)
      }
    }
  }

  /**
   * 移除监听器
   */
  removeListener() {
    window.removeEventListener('message', this.handleMessage)
  }
}

export default IframeMessenger



// WEBPACK FOOTER //
// ./src/utils/iframePostMessage.js